import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {RelayBoard} from '../classes/RelayBoard';
import {Relay} from '../classes/Relay';

const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root'
})
export class RelayBoardService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<RelayBoard[]> {
    return this.httpClient.get<RelayBoard[]>(`${environment.backendApiUrl}/v1/relay-boards`, {headers});
  }

  public addOrEdit(relayBoard: RelayBoard): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/relay-boards`, relayBoard, {headers});
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/relay-boards/` + id, {headers});
  }

  public getRelayBoard(id: number): Observable<RelayBoard> {
    return this.httpClient.get<RelayBoard>(`${environment.backendApiUrl}/v1/relay-boards/` + id, {headers});
  }

  public getCurrentState(): Observable<Relay[]> {
    // TODO replace id=1 to real id of relay board
    return this.httpClient.get<Relay[]>(`${environment.backendApiUrl}/v1/relay-boards/1/state`, {headers});
  }

  public setState(relays: Relay[]): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/relay-boards/state`, relays, {headers});
  }

  public getAllByOffice(officeId: number): Observable<RelayBoard[]> {
    const params = new HttpParams().append('officeId', officeId);
    return this.httpClient.get<RelayBoard[]>(`${environment.backendApiUrl}/v1/relay-boards`, {headers, params});
  }
}
